import React from "react";
import Popup from "reactjs-popup";
import {
  Grid,
  Card,
  Table,
  Page,
  colors,
  Form
} from "tabler-react";
import Linkify from "../Linkify";


class InfoPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.openInfoPopup,
    };
    //this.openModal = this.props.openPopup;
    this.closeInfoModal = this.closeInfoModal.bind(this);
  }

  closeInfoModal() {
    this.props.onChange(false);
  }

  submitReply(e) {
    this.props.onChange(false);
  }


  render() {
    // console.log('admin-engage-score',this.props.openInfoPopup.data)
    const openInfoPopup = this.props.openInfoPopup.open;
    const replyOption = this.props.openInfoPopup.reply || this.state.reply
    const message = this.props.openInfoPopup.data;
    console.log('admin-engage-score', this.props)
    return (
      <div>

        <Popup
          open={openInfoPopup}
          onClose={this.closeInfoModal}
          closeOnDocumentClick
        >


          <div className="card">
            <div className="card-header">

              <div className="card-options">
                <a className="card-options-remove cursorPointer"
                  data-toggle="card-remove"
                  onClick={() => {
                    this.closeInfoModal();
                  }}>
                  <i className="fe fe-x"></i>
                </a>
              </div>
            </div>
            <div className="card-body aligncenter">



              {
                message && message.email &&
                <div>
                  Email: {message && message.email}
                </div>
              }
              {/* <div>
                  Language: {message && message.language}
                </div> */}
              {/* <div>
                Address: {message && message.address}
              </div> */}
              {
                message && message.dob &&
                <div>
                  DOB: {message && message.dob && message.dob.split('T')[0]}
                </div>
              }
              {/* <div>
                  Gender: {message && message.gender}
                </div>
                <div>
                  PatientId: {message && message.patientId}
                </div>
                <div>
                  AppointmentId: {message && message.appointmentId}
                </div>
                <div>
                  pincode: {message && message.pincode}
                </div>
                <div>
                 Suggestions: {message && message.suggestion}
                </div> */}


              {/* <div>
                  Language: {message && message.language}
                </div> */}

              {/* <div>
                  Speciality: {message && message.speciality}
                </div> */}
              {
                message && message.address &&
                <div>
                  Address: {message && message.address}
                </div>
              }
              {
                message && message.pincode &&
                <div>
                  Pincode: {message && message.pincode}
                </div>
              }


              {
                (message && message.testName) &&
                <div>
                  Testname: <Linkify>{message && message.testName}</Linkify>
                </div>
              }

              {
                message && message.callbackPurpose &&
                <div>
                  Purpose : {message && message.callbackPurpose}
                </div>
              }

              {
                message && message.query &&
                <div>
                  Query: {message && message.query}
                </div>
              }

              {
                message && message.crmRes && message.crmRes.response &&
                <div>
                  Response: {message && message.crmRes && message.crmRes.response}
                </div>
              }

              {
                (message && message.paymentObj && message.paymentObj.payNowOrLater === 'NOW') &&
                <>
                  <div>
                    Pay now or later: NOW
                  </div>

                  <div>
                    Payment Status : {message.paymentObj.paymentStatus}
                  </div>

                  {
                    message.paymentObj.paymentId &&
                    <div>
                      Order Id : {message.paymentObj.paymentId}
                    </div>
                  }

                  {
                    (
                      message.paymentObj.paymentObj &&
                      message.paymentObj.paymentObj.mihpayid
                    ) &&
                    <div>
                      Payu Id : {message.paymentObj.paymentObj.mihpayid}
                    </div>
                  }

                  {
                    (
                      message.paymentObj.paymentObj &&
                      message.paymentObj.paymentObj.txnid
                    ) &&
                    <div>
                      txnid : {message.paymentObj.paymentObj.txnid}
                    </div>
                  }


                </>
              }

              {
                message && message.paymentObj && message.paymentObj.payNowOrLater === 'LATER' &&
                <div>
                  Pay now or later: LATER
                </div>
              }

              {/* <Table
                cards={true}
                striped={true}
                responsive={true}
                className="table-vcenter "
              >
                <Table.Header>
                  <Table.Row>
                    <Table.ColHeader>Sl No.</Table.ColHeader>
                    <Table.ColHeader >Entity </Table.ColHeader>
                    <Table.ColHeader>Value</Table.ColHeader>                   
                  </Table.Row>
                </Table.Header>
               
                  <Table.Body>
                    {
                      message
                      && Array.isArray(message)
                      && message.length>0
                      &&  message.map((value, index) => (
                        <Table.Row key={index}>
                          <Table.Col>{index + 1}</Table.Col>
                          <Table.Col>{value.entity}</Table.Col>
                          <Table.Col className="text-nowrap">{value.value}</Table.Col>
                          
                        </Table.Row>
                      ))
                     
                    }
                  </Table.Body>
                 
                
              </Table> */}


            </div>

          </div>

        </Popup>
      </div>
    );
  }
}

export default InfoPopup